import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxFormPopupComponent } from './tax-form-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ButtonModule, FormFieldModule, InputModule } from '@shared';

import { LinkModule } from '@shared/link';
import { SelectModule } from '@shared/select';

@NgModule({
  declarations: [TaxFormPopupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    MatDialogModule,
    FormFieldModule,
    SelectModule,
    LinkModule,
    InputModule,
  ],
  exports: [TaxFormPopupComponent],
})
export class TaxFormPopupModule {}
